<template>
    <el-row>
        <h2>欢迎进入云上数据中心</h2>
        <el-col :span="20" :offset="2" class="c_margin_top">
            <el-calendar>
                <template slot="dateCell" slot-scope="{date, data}">
                    <el-row :gutter="5" >
                        <el-col :span="10">
                            <span class="font-size-small">{{ data.day.split('-').slice(1).join('-') }}</span>

                        </el-col>
                        <el-col :span="14">
                            <p :class="dateGroup[data.day]?'font-size-small is-selected':'font-size-small'">
                                上传:{{dateGroup[data.day]?dateGroup[data.day]:'0'}}
                            </p>
                            <p :class="uploadedDateGroup[data.day]?'font-size-small is-selected':'font-size-small'">
                                上架:{{uploadedDateGroup[data.day]?uploadedDateGroup[data.day]:'0'}}
                            </p>
                        </el-col>
                    </el-row>

                    <p>

                    </p>
                    <p>

                    </p>
                </template>

            </el-calendar>
        </el-col>
    </el-row>
</template>

<script>
    export default {
        name: "Overview",
        data() {
            return {
                dateGroup: {},
                uploadedDateGroup: {}
            }
        },
        created() {
            this.$api.post('/datacenter/validateLogin', {}, (res) => {
                if (res.data.code == 200) {
            let _this = this;
            this.$api.get('/datacenter/querySepMethodsByDay', {}, (res) => {
                if(res.data.code == 200) {
                    _this.dateGroup = res.data.data;

                }else {
                    _this.$message.error('按天获取数据统计失败');
                }
            })
            this.$api.get('/datacenter/queryUploadedMethodByDay',{}, (res) => {
                if (res.data.code == 200) {
                    _this.uploadedDateGroup = res.data.data;
                }else {
                    _this.$message.error('按天获取已公开数据');
                }
            })
                }
            })

        }
    }
</script>

<style scoped>
    @import '../assets/text-font.css';
    .is-selected {
        color: #1989FA;
    }

</style>